"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToCallbacks = void 0;
const lodash_1 = require("lodash");
const operation_1 = require("../operation");
function translateToCallbacks(callbacks) {
    const callbackEntries = lodash_1.entries(callbacks);
    if (!callbackEntries.length)
        return;
    return callbackEntries.reduce((results, [callbackName, path2Methods]) => {
        for (const [path, method2Op] of lodash_1.entries(path2Methods)) {
            for (const [method, op] of lodash_1.entries(method2Op)) {
                const document = {
                    openapi: '3',
                    info: { title: '', version: '1' },
                    paths: { [path]: { [method]: op } },
                };
                results.push(Object.assign(Object.assign({}, operation_1.transformOas3Operation({
                    document,
                    method,
                    path,
                })), { callbackName }));
            }
        }
        return results;
    }, []);
}
exports.translateToCallbacks = translateToCallbacks;
//# sourceMappingURL=callbacks.js.map